var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconThreeDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3354 7.99998C14.3354 7.26352 13.7384 6.6665 13.0019 6.6665C12.2655 6.6665 11.6685 7.26352 11.6685 7.99998C11.6685 8.73643 12.2655 9.33345 13.0019 9.33345C13.7384 9.33345 14.3354 8.73643 14.3354 7.99998Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33345 7.99998C9.33345 7.26352 8.73643 6.6665 7.99998 6.6665C7.26352 6.6665 6.6665 7.26352 6.6665 7.99998C6.6665 8.73643 7.26352 9.33345 7.99998 9.33345C8.73643 9.33345 9.33345 8.73643 9.33345 7.99998Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33198 7.99998C4.33198 7.26352 3.73497 6.6665 2.99851 6.6665C2.26205 6.6665 1.66504 7.26352 1.66504 7.99998C1.66504 8.73643 2.26205 9.33345 2.99851 9.33345C3.73497 9.33345 4.33198 8.73643 4.33198 7.99998Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThreeDots);
export default __webpack_public_path__ + "static/media/icon-three-dots.82f9cad8d5b83438c6ba7499a63c6917.svg";
export { ForwardRef as ReactComponent };